import React, { createContext, useContext, useMemo } from 'react';
import { getStatsigExperimentConfig } from '../services/statsig';
var Context = /*#__PURE__*/createContext(undefined);
export var ExperimentContext = function ExperimentContext(_ref) {
  var children = _ref.children;
  var config = useMemo(function () {
    return getStatsigExperimentConfig();
  }, []);
  return /*#__PURE__*/React.createElement(Context.Provider, {
    value: config
  }, children);
};
export var useExperimentContext = function useExperimentContext() {
  return useContext(Context);
};